var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.7 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.4,2A4.1,4.1,0,1,1,6.3,6.1,4,4,0,0,1,10.4,2m0-2a6.1,6.1,0,1,0,6,6.1,6.1,6.1,0,0,0-6-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.7,24.1h-2V20.7a5.1,5.1,0,0,0-5.2-5.1H7.2A5.1,5.1,0,0,0,2,20.7v3.4H0V20.7a7.2,7.2,0,0,1,7.2-7.2h6.3a7.2,7.2,0,0,1,7.2,7.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5436b40e009951d211c95ec448af1f4f.svg";
export { ForwardRef as ReactComponent };